import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Scrollbar from 'src/components/scrollbar';
//
import { HeaderSimple as Header } from '../_common';
import { HEADER } from '../config-layout';

// ----------------------------------------------------------------------

export default function AuthModernCompactLayout({ children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100dvh', overflow: 'hidden' }}>
      <Header />
      <Box
        sx={{
          mt: { xs: `${HEADER.H_MOBILE + 1}px`, md: `${HEADER.H_DESKTOP + 1}px` },
          flex: '1 1 auto',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <Scrollbar sx={{ height: 1 }}>
          <Box
            component="main"
            sx={{
              py: 12,
              display: 'flex',
              minHeight: '100%',
              textAlign: 'center',
              px: { xs: 2, md: 0 },
              position: 'relative',
              alignItems: 'center',
              justifyContent: 'center',
              '&:before': {
                width: 1,
                height: 1,
                zIndex: -1,
                content: "''",
                opacity: 0.24,
                position: 'absolute',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundImage: 'url(/assets/background/overlay_4.jpg)',
              },
            }}
          >
            <Card
              sx={{
                py: 5,
                px: 3,
                maxWidth: 420,
              }}
            >
              {children}
            </Card>
          </Box>
        </Scrollbar>
      </Box>
    </Box>
  );
}

AuthModernCompactLayout.propTypes = {
  children: PropTypes.node,
};
